import { escapeRegExp } from 'src/utils/strings';

const REDACTION_CHARACTER = '▓';
const WORD_CHARACTER = /[\p{L}\p{N}_]/u;
const NOT_PRECEDED_BY_WORD_CHARACTER = '(?<![\\p{L}\\p{N}_])';
const NOT_FOLLOWED_BY_WORD_CHARACTER = '(?![\\p{L}\\p{N}_])';
/*
 * The selection comes from the rendered DOM as plain text, while the message body is HTML:
 * whitespace may be collapsed or encoded as `&nbsp;`, and `& < >` are entity-encoded.
 */
const WHITESPACE_RUN = '(?:\\s|&nbsp;)+';
const HTML_ENTITY_ALTERNATIVES: Record<string, string> = {
  '&': '(?:&|&amp;)',
  '<': '(?:<|&lt;)',
  '>': '(?:>|&gt;)',
};
const HTML_TAG_SPLIT = /(<[^>]*>)/;
const HTML_TAG = /^<[^>]*>$/;

export function redactSelection(text: string, selectedText: string): string {
  return selectedText
    .split(/\r?\n/)
    .map((line) => line.trim())
    .filter(Boolean)
    .reduce((redacted, line) => redactLine(redacted, line), text);
}

function redactLine(text: string, line: string): string {
  const pattern = buildSelectionPattern(line);
  const redactedPart = REDACTION_CHARACTER.repeat(Array.from(line).length);

  return text
    .split(HTML_TAG_SPLIT)
    .map((segment) =>
      HTML_TAG.test(segment) ? segment : segment.replace(pattern, redactedPart),
    )
    .join('');
}

function buildSelectionPattern(line: string): RegExp {
  const characters = Array.from(line);
  const leading = WORD_CHARACTER.test(characters[0]) ? NOT_PRECEDED_BY_WORD_CHARACTER : '';
  const trailing = WORD_CHARACTER.test(characters[characters.length - 1])
    ? NOT_FOLLOWED_BY_WORD_CHARACTER
    : '';
  const body = line.split(/\s+/).map(toLiteralPattern).join(WHITESPACE_RUN);

  return new RegExp(`${leading}${body}${trailing}`, 'gu');
}

function toLiteralPattern(word: string): string {
  return Array.from(word)
    .map((character) => HTML_ENTITY_ALTERNATIVES[character] ?? escapeRegExp(character))
    .join('');
}
